import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSpotify,
  faInstagram,
  faFacebook,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import "./Connect.css"; // Import the external CSS file

const API_BASE = process.env.REACT_APP_FRONTPAGE_API || "http://localhost:5010/api";
const DEFAULT_CONNECT_CONTENT = {
  heading: "DODSEGO\n@\nGMAIL.COM",
  email: "dodsego@gmail.com",
  spotifyUrl: "https://open.spotify.com/artist/2nKkYeW42RSx0jPNKQZ64U?si=e4FrAbw0SGaWav4Jg5SaEA",
  instagramUrl: "https://www.instagram.com/dodsegoband/",
  facebookUrl: "https://facebook.com/dodsegoband",
  youtubeUrl: "https://www.youtube.com/@Dodsego",
};

const Connect = () => {
  const [connectContent, setConnectContent] = useState(DEFAULT_CONNECT_CONTENT);

  useEffect(() => {
    document.body.classList.add("connect-page-no-scroll");
    document.documentElement.classList.add("connect-page-no-scroll");

    return () => {
      document.body.classList.remove("connect-page-no-scroll");
      document.documentElement.classList.remove("connect-page-no-scroll");
    };
  }, []);

  useEffect(() => {
    let active = true;
    const loadContent = async () => {
      try {
        const response = await fetch(`${API_BASE}/connect-content`);
        if (!response.ok) throw new Error("Failed connect-content fetch");
        const payload = await response.json();
        if (!active) return;
        setConnectContent({
          heading: String(payload?.heading || DEFAULT_CONNECT_CONTENT.heading),
          email: String(payload?.email || DEFAULT_CONNECT_CONTENT.email),
          spotifyUrl: String(payload?.spotifyUrl || DEFAULT_CONNECT_CONTENT.spotifyUrl),
          instagramUrl: String(payload?.instagramUrl || DEFAULT_CONNECT_CONTENT.instagramUrl),
          facebookUrl: String(payload?.facebookUrl || DEFAULT_CONNECT_CONTENT.facebookUrl),
          youtubeUrl: String(payload?.youtubeUrl || DEFAULT_CONNECT_CONTENT.youtubeUrl),
        });
      } catch {
        if (!active) return;
        setConnectContent(DEFAULT_CONNECT_CONTENT);
      }
    };
    loadContent();
    return () => {
      active = false;
    };
  }, []);

  return (
    <div className="landing-page" id="connect">
      <div className="signup">
        <div className="social-icons-bottom">
          <div style={{ width: "100%", display: "flex", justifyContent: "center", gap: "1rem", marginTop: "20px" }}>
            <a className="spotify" href={connectContent.spotifyUrl} target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faSpotify} size="2x" />
            </a>
            <a className="instagram" href={connectContent.instagramUrl} target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faInstagram} size="2x" />
            </a>
            <a className="facebook" href={connectContent.facebookUrl} target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faFacebook} size="2x" />
            </a>
            <a className="youtube" href={connectContent.youtubeUrl} target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faYoutube} size="2x" />
            </a>
            <a className="email" href={`mailto:${connectContent.email}`}>
              <FontAwesomeIcon icon={faEnvelope} size="2x" />
            </a>
          </div>
        </div>
        {/* Newsletter Signup */}
        {/*<form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            className="newsletter-input"
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <br></br>
          <br></br>
          <button type="submit" className="newsletter-button">Submit</button>
        </form>*/}
        <h1 style={{ whiteSpace: "pre-line" }}>{connectContent.heading}</h1>
      </div>
    </div>
  );
};

export default Connect;